// routes.js
import App from './App';

const routes = [
  {
    path: "/*",
    element: <App />,
  },
];

export default routes;
